export const multipleVideoPlaylistState = {
  state: {
    currentCarouselId: null,
    selectedTabId: null,
    tabsMap: new Map(),
    playlist: null,
  },
  setState(key, value) {
    if (Object.prototype.hasOwnProperty.call(this.state, key)) {
      this.state[key] = value;
    }
  },
  getState(key) {
    if (Object.prototype.hasOwnProperty.call(this.state, key)) {
      return this.state[key];
    }
    return undefined;
  },
};
